'use strict';

module.exports = function isNegativeZero(number) {
	return number === 0 && (1 / number) === -Infinity;
};




//////////////////
// WEBPACK FOOTER
// ./node_modules/_is-negative-zero@2.0.0@is-negative-zero/index.js
// module id = 1068
// module chunks = 0 1